import { ThisGorillaUtils } from "@thisgorilla/primate-ds";
import { useEffect } from "react";
import styled, { useTheme } from "styled-components";
import { API_CALLS } from "../../../../API/api_calls";
import { Divider, hideScrollBar } from "../../../../commonStyles";
import { useAppSelector } from "../../../../redux";
import { FlexColumn } from "../../../Common/Styles";
import { DiscoverPeople } from "./DiscoverPeople";
import { PeopleYouMayKnow } from "./PeopleYouMayKnow";
import { RecommendedJobsList } from "./RecommendedJobsList";
import AdUnit from "./AdUnit";

export const RightPanel = () => {
  const { Color } = useTheme();
  const { getRecommendedJobs_API_STATUS, peopleYouMightKnow_API_STATUS } =
    useAppSelector((state) => state.me);

  useEffect(() => {
    if (getRecommendedJobs_API_STATUS !== "idle") return;

    API_CALLS.ME.getRecommendedJobs();
  }, [getRecommendedJobs_API_STATUS]);

  useEffect(() => {
    if (peopleYouMightKnow_API_STATUS !== "idle") return;

    API_CALLS.ME.getPeopleYouMightKnow();
  }, [peopleYouMightKnow_API_STATUS]);

  return (
    <ScrollContainer>
      <Container className="right-panel">
        <AdUnit />
        <DiscoverPeople />
        <Divider $color={Color.border["ui-border-subtle"].value} />
        <RecommendedJobsList />
        <Divider $color={Color.border["ui-border-subtle"].value} />
        <PeopleYouMayKnow />
      </Container>
    </ScrollContainer>
  );
};

const ScrollContainer = styled.div`
  max-height: calc(100vh - ${ThisGorillaUtils.convertPxToRem("136")}rem);
  overflow-y: scroll;
  position: sticky;
  z-index: 1;
  top: ${ThisGorillaUtils.convertPxToRem("104")}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  ${hideScrollBar}
`;
const Container = styled(FlexColumn)`
  width: ${ThisGorillaUtils.convertPxToRem("332")}rem;
  gap: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-6"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;
